import { render, staticRenderFns } from "./VImageUploader.vue?vue&type=template&id=27c8c6d0&"
import script from "./VImageUploader.vue?vue&type=script&lang=js&"
export * from "./VImageUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports